/**
 * Como qualquer tela abre a ficha de uma OP. Funções PURAS.
 *
 * A regra do produto é "clicar numa OP abre a ficha da OP, em qualquer tela". Para isso
 * valer sem cada tela inventar o seu jeito, a ficha vive na BARRA DE ENDEREÇO: a linha
 * clicada escreve `?op=<uid>` e a ficha abre. O link também pode ser mandado para
 * alguém, que é o que faltava quando a ficha era estado de componente.
 *
 * A chave é a mesma que a Carteira e o Mapa já usavam, então todo link antigo continua
 * valendo.
 */

/** A chave da OP aberta: `/fila?op=<uid da OP>`. */
export const FICHA_DA_OP_PARAM = 'op';

/** O que a linha escreve no endereço ao ser clicada. */
export function abrirFichaDaOpPatch(uid: string): Record<string, string | null> {
  return { [FICHA_DA_OP_PARAM]: uid === '' ? null : uid };
}
